import React, { FC, memo } from 'react';
import { DivItem, DivTitle, DivWrapper, H4Subtitle, DivFileslistWrapper, H5PrinterTitle } from './styles';
import { getKsfDirectoryList } from './utils';
import FnButtonIcon from '../FnButtonIcon';
import { FnButtonIconTypes } from '../FnButtonIcon/constants';
import { downloadFile } from '../../../util/download';
import { TKsfDirectoryItem } from '../../../commonTypes/basic';
import FnAntModal from '../../blocks/FnAntModal';
import { FnAntModalWidth } from '../../blocks/FnAntModal/constants';

interface Props {
  title?: string;
  data: TKsfDirectoryItem[];
  size: FnAntModalWidth;
  isOpen: boolean;
  onClose: () => void;
}

const FnFilesModal: FC<Props> = ({ title = 'KSF Directory', data, size, isOpen, onClose }) => {
  const handleClick = (uri) => downloadFile(uri);
  const ksfDirectoryList = getKsfDirectoryList(data);

  const renderItems = (files) => {
    if (!Array.isArray(files)) {
      return null;
    }

    return files.map(({ name, uri }) => {
      return name && uri ? (
        <DivItem key={uri}>
          <FnButtonIcon viewType={FnButtonIconTypes.Link} text={name} onClick={() => handleClick(uri)} />
        </DivItem>
      ) : null;
    });
  };

  const renderCategories = (categories) => {
    if (!Array.isArray(categories)) {
      return null;
    }
    return categories.map(({ files, name }) => {
      return Array.isArray(files) && files.length ? (
        <DivItem key={name}>
          {name && <H4Subtitle>{name}</H4Subtitle>}
          {renderItems(files)}
        </DivItem>
      ) : null;
    });
  };

  return (
    <FnAntModal isOpen={isOpen} titleText={title} width={size} onClose={onClose} zIndex={1041} >
      <DivWrapper>
        {ksfDirectoryList.map(({ name, files, categories }) => (
          <div key={name}>
            <DivTitle>{name}</DivTitle>
            {renderItems(files)}
            {renderCategories(categories)}
          </div>
        ))}
      </DivWrapper>
    </FnAntModal>
  );
};

export default memo(FnFilesModal);
